var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullet-wrap"},_vm._l((_vm.showingBullets),function(item){return _c('div',{key:item.id,staticClass:"bullet-item",style:({color: item.color}),attrs:{"data-line":item.line}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }